import { render, staticRenderFns } from "./l-task.vue?vue&type=template&id=12f92562&scoped=true"
import script from "./l-task.vue?vue&type=script&lang=js"
export * from "./l-task.vue?vue&type=script&lang=js"
import style0 from "./l-task.vue?vue&type=style&index=0&id=12f92562&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f92562",
  null
  
)

export default component.exports